module.exports = __webpack_public_path__ + "img/laugh.debfecc5.svg";